import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { connect } from "react-redux";

import ZoomableCarousel from "../../ProductDetails/ZoomableCarousel";

class ProductCarousel extends Component {
  carouselRef = React.createRef();
  mainImageRef = React.createRef();
  state = { carouselWidth: null, mainImageHeight: 300 };
  setCarouselWidth = () => {
    if (this.carouselRef.current) {
      this.setState({ carouselWidth: this.carouselRef.current.clientWidth });
    }
  };

  componentDidMount() {
    this.setCarouselWidth();
    window.addEventListener("resize", this.setCarouselWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.setCarouselWidth);
  }

  render() {
    let images = [];
    const { current_product } = this.props;
    const { carouselWidth } = this.state;
    const hasThumbs = current_product
      ? current_product.photo_thumb 
      : null;
    
      images = [
        <div key="Main Photo">
          <img
            src={this.props.current_product.photo}
            style={{ height: this.state.mainImageHeight, objectFit: "cover" }}
          />
        </div>,
      ];
    

    return (
      <div
        className=" mt-5"
        ref={this.carouselRef}
        style={{ position: "relative" }}
      >

        {carouselWidth && (
          <ZoomableCarousel
            height={this.state.mainImageHeight}
            initialSlide={0}
            slides={images}
            carouselWidth={carouselWidth}
            language={this.props.language}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    current_product: state.b2b.selectedProduct.product,
    auth: state.auth,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(ProductCarousel);
